export default function onDocReady(callback) {
  if (["complete", "interactive"].indexOf(document.readyState) > -1) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}
